export const DEFAULT_EMAIL_TEMPLATES = [
  {
    key: 'staff.set_password',
    name: 'Staff set password',
    subject: 'Set up your SafeguardPro login',
    html_body:
      '<p>Hello {{staff_name}},</p><p>Your SafeguardPro account is ready. Use the link below to set a password:</p><p><a href="{{action_url}}">Set your password</a></p><p>After setup, sign in here: <a href="{{login_url}}">{{login_url}}</a></p><p>If you were not expecting this, please contact your manager.</p>',
    text_body:
      'Hello {{staff_name}},\n\nYour SafeguardPro account is ready. Use the link below to set a password:\n{{action_url}}\n\nStaff/admin login:\n{{login_url}}\n\nIf you were not expecting this, please contact your manager.'
  },
  {
    key: 'staff.reset_password',
    name: 'Staff reset password',
    subject: 'Reset your SafeguardPro password',
    html_body:
      '<p>Hello {{staff_name}},</p><p>We received a request to reset your password. Use the link below to choose a new one:</p><p><a href="{{action_url}}">Reset password</a></p><p>This link expires on {{expires_at}}.</p>',
    text_body:
      'Hello {{staff_name}},\n\nWe received a request to reset your password. Use the link below to choose a new one:\n{{action_url}}\n\nThis link expires on {{expires_at}}.'
  },
  {
    key: 'staff.temp_password',
    name: 'Staff temporary password',
    subject: 'Your SafeguardPro temporary password',
    html_body:
      '<p>Hello {{staff_name}},</p><p>Your SafeguardPro login has been created.</p><p><strong>Login:</strong> {{login_email}}<br/><strong>Temporary password:</strong> {{temp_password}}</p><p>Sign in here: <a href="{{login_url}}">{{login_url}}</a></p><p>Please change this password after you sign in.</p>',
    text_body:
      'Hello {{staff_name}},\n\nYour SafeguardPro login has been created.\nLogin: {{login_email}}\nTemporary password: {{temp_password}}\n\nStaff/admin login:\n{{login_url}}\n\nPlease change this password after you sign in.'
  },
  {
    key: 'reminder.overdue',
    name: 'Overdue reminder',
    subject: 'Overdue reminder: {{item_title}}',
    html_body:
      '<p>Hello {{staff_name}},</p><p>This is a reminder that <strong>{{item_title}}</strong> was due back on {{due_date}}.</p><p>Please arrange a return or update the record.</p><p><a href="{{action_url}}">View item</a></p>',
    text_body:
      'Hello {{staff_name}},\n\nThis is a reminder that {{item_title}} was due back on {{due_date}}.\n\nPlease arrange a return or update the record.\n{{action_url}}'
  },
  {
    key: 'inventory.alert',
    name: 'Inventory alert',
    subject: 'Inventory alert: {{item_title}}',
    html_body:
      '<p>Hello {{staff_name}},</p><p>There is an inventory alert for {{item_title}}.</p><p><a href="{{action_url}}">View item</a></p>',
    text_body:
      'Hello {{staff_name}},\n\nThere is an inventory alert for {{item_title}}.\n{{action_url}}'
  },
  {
    key: 'student.portal_reset',
    name: 'Student portal reset password',
    subject: 'Reset your student portal password',
    html_body:
      '<p>Hello {{student_name}},</p><p>Use the link below to reset your student portal password:</p><p><a href="{{action_url}}">Reset password</a></p><p>Student portal login: <a href="{{login_url}}">{{login_url}}</a></p><p>This link expires on {{expires_at}}.</p>',
    text_body:
      'Hello {{student_name}},\n\nUse the link below to reset your student portal password:\n{{action_url}}\n\nStudent portal login:\n{{login_url}}\n\nThis link expires on {{expires_at}}.'
  }
];

export const TEMPLATE_PLACEHOLDERS = {
  'staff.set_password': ['staff_name', 'action_url', 'login_url', 'site_name'],
  'staff.reset_password': ['staff_name', 'action_url', 'expires_at', 'site_name'],
  'staff.temp_password': ['staff_name', 'login_email', 'temp_password', 'login_url', 'site_name'],
  'reminder.overdue': ['staff_name', 'item_title', 'due_date', 'action_url', 'site_name'],
  'inventory.alert': ['staff_name', 'item_title', 'action_url', 'site_name']
  ,
  'student.portal_reset': ['student_name', 'action_url', 'login_url', 'expires_at', 'site_name']
};

export const DEFAULT_TEMPLATE_SAMPLES = {
  'staff.set_password': {
    staff_name: 'Jordan Rivers',
    action_url: 'https://safeguardpro.local/reset?token=demo',
    login_url: 'https://safeguardpro.local/login',
    site_name: 'SafeguardPro'
  },
  'staff.reset_password': {
    staff_name: 'Jordan Rivers',
    action_url: 'https://safeguardpro.local/reset?token=demo',
    expires_at: 'Tomorrow 10:00',
    site_name: 'SafeguardPro'
  },
  'staff.temp_password': {
    staff_name: 'Jordan Rivers',
    login_email: 'jordan@example.com',
    temp_password: 'TempPass123!',
    login_url: 'https://safeguardpro.local/login',
    site_name: 'SafeguardPro'
  },
  'reminder.overdue': {
    staff_name: 'Jordan Rivers',
    item_title: 'HP Laptop (INV-204)',
    due_date: 'Feb 12, 2026',
    action_url: 'https://safeguardpro.local/inventory/item',
    site_name: 'SafeguardPro'
  },
  'inventory.alert': {
    staff_name: 'Jordan Rivers',
    item_title: 'Surface Pro (INV-110)',
    action_url: 'https://safeguardpro.local/inventory/item',
    site_name: 'SafeguardPro'
  },
  'student.portal_reset': {
    student_name: 'Alex Morgan',
    action_url: 'https://safeguardpro.local/student-portal/reset?token=demo',
    login_url: 'https://safeguardpro.local/student-portal/login',
    expires_at: 'Tomorrow 10:00',
    site_name: 'SafeguardPro'
  }
};
